import axios from "axios";
const url = process.env.REACT_APP_BACKEND_URL;

export async function addLeaderboard(
    authToken,
    title
) {

    return axios.post(url + "/leaders", {
        title
    }, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        })
        .then(function (response) {
            console.log(response);
        })
        .catch(function (error) {
            console.log(error);
        });

}

export async function getLeadersBy(boardName, lim) {
    return axios({
        method: 'get',
        url: url + "/leaders/" + boardName,
        data: {limit: lim}
     
    }).then(res => {
        return res.data;
    });
}




export async function updateLeaderboard(
    authToken,
    leaderboardName,
    userId,
    score
) {

    return axios.post(url + "/leaders/update/"+ leaderboardName, {      
        userId,
        score    
    }, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        })
        .then(function (response) {
            console.log(response);
        })
        .catch(function (error) {
            console.log(error);
        });

}


// WEBPACK FOOTER //
// ./src/api-calls/leaders.js